// @mui
import { InputAdornment, ClickAwayListener } from '@mui/material';
// components
import Iconify from 'src/minimals/components/Iconify';
import InputStyle from './InputStyle';
import { useTranslation } from 'react-i18next';

export default function ChatContactSearch({
  query,
  onChange,
  onFocus,
  onClickAway,
}) {
  const { t } = useTranslation();
  return (
    <ClickAwayListener onClickAway={onClickAway}>
      <InputStyle
        fullWidth
        size="small"
        value={query}
        onFocus={onFocus}
        onChange={onChange}
        placeholder={t('chat.contacts_search_input_placeholder')}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <Iconify
                icon="eva:search-fill"
                sx={{ color: 'text.disabled', width: 20, height: 20 }}
              />
            </InputAdornment>
          ),
        }}
        sx={{ mt: 2 }}
      />
    </ClickAwayListener>
  );
}
